import React, { useMemo, useState } from 'react';
import { AuraChatContext } from './context';

type Props = {
  canToggleAuraChat: boolean;
  children: React.ReactNode;
};

export const AuraChatContainer = ({ canToggleAuraChat, children }: React.PropsWithChildren<Props>) => {
  const [auraChatStatus, setAuraChatStatus] = useState<boolean>(false);

  const ctx = useMemo(() => ({
    canToggleAuraChat,
    auraChatStatus,
    setAuraChatStatus,
  }), [canToggleAuraChat, auraChatStatus]);

  return (
    <AuraChatContext.Provider value={ctx}>
      {children}
    </AuraChatContext.Provider>
  );
};
